import { Box, Button, Checkbox, Typography } from "@mui/material";
import React, { useState } from "react";
import EastIcon from "@mui/icons-material/East";
import { useNavigate, useParams } from "react-router-dom";

const ReviewBox = ({ url,  handleSubmit,  }) => {
  const [checked, setChecked] = useState(false);
  const navigate = useNavigate();
  const {id}=useParams();
  console.log(id,"id")

  const item=url?.includes("gri")? "reviewGRI" :"reviewBRSR";

  console.log(item,"url1");
  const url1=url?.includes("gri")? "/gri" :"/brsr";
  const link=url?.includes("gri")? `/gri/review/${id}`:`/brsr/review/${id}`

  return (
    <Box
      sx={{
        background: "#1C486B",
        my: "2rem",
        p: 3,
        borderRadius: "10px",
        //   width: "36%",
      }}
    >
      {" "}
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          fontStyle: "inter",
          textTransform: "uppercase",
          color: "#ffffff",
        }}
      >
        Review & submit answers
      </Typography>
      <Box
        display="flex"
        // alignItems="center"
        gap={0.5}
        sx={{ color: "white", ml: "-0.6rem", mt: "1rem" }} // Applies white to text
      >
        <Box>
          <Checkbox
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            sx={{
              color: "white",
              "&.Mui-checked": {
                color: "white",
              },
            }}
          />
        </Box>
        <Typography
          sx={{
            fontFamily: "inter",
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "24px",
            mt: "0.5rem",
            color: "white",
          }}
        >
          I have reviewed my entries and confirm they are accurate.
        </Typography>
      </Box>
      <Typography
        sx={{
          fontFamily: "inter",
          fontWeight: 400,
          fontSize: "14px",
          lineHeight: "24px",
          ml: "2.2rem",
          color: "white",
        }}
      >
        Checking this box confirms that you have reviewed your data. Once
        checked, the Submit button will be activated.
      </Typography>
      <Box
        sx={{ display: "flex", justifyContent: "space-between", mt: "2rem" }}
      >
        <Button
          onClick={() => {
            localStorage.setItem(item, JSON.stringify(false));
            navigate(link);
          }}
          disabled={!checked}
          sx={{
            backgroundColor: "transparent",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "24px",
            fontFamily: "inter", // corrected from `fontStyle`
            borderRadius: "5px",
            border: "1px solid white",
            height: "2.5rem",
            px: "1rem",
            width: "18rem",
            alignItems: "center",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#ffffff",
              color: "#000000", // optional: change on hover if needed
            },
            "&.Mui-disabled": {
              color: "#ffffff", // maintain white text when disabled
              border: "1px solid white", // keep border
              opacity: 0.5, // optional: indicate disabled visually
            },
          }}
        >
          Mark as reviewed and Submit
        </Button>{" "}
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          {" "}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              height: "2.5rem",
            }}
          >
            <Button
              onClick={() => navigate(url1)}
              sx={{
                backgroundColor: "transparent",
                textTransform: "none",
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "24px",
                fontStyle: "inter",
                borderRadius: "5px",
                border: "1px solid white",
                px: "1rem",
                width: "11rem",
                alignItems: "center",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#fffffff", // keep white background on hover
                },
              }}
            >
              Review rest later
            </Button>
            <Button
              onClick={() => {
                handleSubmit();
              }}
              sx={{
                backgroundColor: "white",
                textTransform: "none",
                background: "white",
                color: "#1C486B",
                fontWeight: 400,
                fontSize: "16px",
                lineHeight: "24px",
                fontStyle: "inter",
                borderRadius: "5px",
                border: "none",
                px: "1rem",
                width: "8rem",
                alignItems: "center",
                "&:hover": {
                  backgroundColor: "#ffffff", // keep white background on hover
                },
              }}
            >
              <span>
                Next <EastIcon sx={{ ml: 2 }} />
              </span>
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ReviewBox;
